import { FileText, Image, Globe, Megaphone, CheckCircle2, Clock } from "lucide-react";

const items = [
  { icon: Globe, title: "Foundation Website v1", status: "Approved", ago: "2d ago" },
  { icon: FileText, title: "Brand Voice Guide", status: "Approved", ago: "5d ago" },
  { icon: Image, title: "Hero imagery pack", status: "In review", ago: "1d ago" },
  { icon: Megaphone, title: "Google Ads launch plan", status: "Awaiting approval", ago: "4h ago" },
  { icon: FileText, title: "SEO content cluster — Crowns", status: "In review", ago: "6h ago" },
];

export default function PortalDeliverables() {
  return (
    <div>
      <div className="eyebrow">// Deliverables</div>
      <h1 className="display-lg text-silver-50 mt-2">Inbox</h1>
      <div className="mt-8 grid gap-4">
        {items.map(({ icon: Icon, title, status, ago }) => {
          const approved = status === "Approved";
          return (
            <div key={title} className="panel p-5 flex items-center gap-5">
              <div className="h-12 w-12 rounded-md bg-ink-800 border border-ink-700 flex items-center justify-center text-brand-blue">
                <Icon size={20} />
              </div>
              <div className="flex-1">
                <div className="font-display font-semibold text-silver-50">{title}</div>
                <div className="text-xs font-mono text-silver-300 uppercase tracking-widest mt-1">// {ago}</div>
              </div>
              <div className={approved ? "chip" : "chip-red"}>
                {approved ? <CheckCircle2 size={10} /> : <Clock size={10} />} {status}
              </div>
              <button className="btn-ghost">Open</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
